import { formatDateShortMonthWithoutYear } from '@ami/react/core';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { LeadTimeSubComponentOutput, LeadTimeUnit } from '../quoteProductLeadTimeService';
import DaysConversionLeadTimeLabel from './DaysConversionLeadTimeLabel';
import WeeksConversionLeadTimeLabel from './WeeksConversionLeadTimeLabel';
import { leadTimeInDaysCutoff } from './leadTimeCalculator';
import moment from 'moment';

const LeadTimeLabel = ({
  leadTime
}) => {
  if (!leadTime)
    return null;

  const number = leadTime.overrideValue ? leadTime.overrideValue ?? 0 : leadTime.value;
  if (number === null || number === undefined)
    return <Fragment> Call </Fragment>;

  const unit = leadTime.unit;
  const availableOn = leadTime.overrideAvailableOn ? leadTime.overrideAvailableOn : leadTime.availableOn;
  const displayHours = unit === LeadTimeUnit.Hours && (number > 1 || number === 0) ? `${number} Hours` : `${number} Hour`;
  const displayDays = unit === LeadTimeUnit.Days && (number > 1 || number === 0) ? `${number}  Days` : `${number}  Day`;
  const numberDays = unit === LeadTimeUnit.Hours ? Math.ceil(number / 8) : number;
  const isFutureDate = moment(availableOn).diff(moment(), "days") > 0;

  switch (number) {
    case 0:
      return <Fragment> 0 {unit} </Fragment>;
    default:
      return (
        <Fragment>
          {unit === LeadTimeUnit.Hours && (
            <Fragment>
              {displayHours}
              {' '}
              ({<DaysConversionLeadTimeLabel leadTimeHours={number} />})

              {numberDays > leadTimeInDaysCutoff && (
                <Fragment>
                  {' '}
                  (<WeeksConversionLeadTimeLabel leadTimeDays={numberDays} roundToNearestWeek={true} />)
                </Fragment>
              )}
            </Fragment>
          )}
          {unit === LeadTimeUnit.Days && (
            <Fragment>
              {displayDays}
              {' '}
              (<WeeksConversionLeadTimeLabel leadTimeDays={number} roundToNearestWeek={true} />)
            </Fragment>
          )}
          {availableOn && isFutureDate && (
            ` after ${formatDateShortMonthWithoutYear(availableOn)}`
          )}
        </Fragment>
      );
  }
};

LeadTimeLabel.propTypes = {
  leadTime: PropTypes.instanceOf(LeadTimeSubComponentOutput)
    .isRequired
};

export default LeadTimeLabel;
